import { render } from "./PantryDetailMenuView.vue?vue&type=template&id=a734a1b0&ts=true"
import script from "./PantryDetailMenuView.vue?vue&type=script&lang=ts"
export * from "./PantryDetailMenuView.vue?vue&type=script&lang=ts"

import "./PantryDetailMenuView.vue?vue&type=style&index=0&id=a734a1b0&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__